import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { getVisaRequestData } from "../../../../store/Api";

export default function PaymentPopup({
  setShowPromptElement,
  showPromptElement,
  propData,
}) {
  console.log("propData........data.....", propData);
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState();
  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const [date, setDate] = useState(null);
  const handleDateChange = (event) => {
    console.log("event to be seen here.......", event);
  };
  console.log("propData.....propData", propData);
  const submitHandler = async (e, fileData, propData) => {
    console.log("fileData......", fileData, amount, date);
    e.preventDefault();
    setLoading(true);
    if (amount === 0) {
      dispatch(
        setAppError({
          msg: "Invoice amount should be greater then 0",
        })
      );
      return;
    }

    let total =
      parseInt(
        propData?.amount_received === null ? 0 : propData?.amount_received
      ) + parseInt(propData?.credit_note === null ? 0 : propData?.credit_note);

    const invoiceAmount = parseFloat(propData.invoice_amount);
    const totalValue = parseFloat(total);
    const amountValue = parseFloat(amount);

    console.log(
      "ghdtftedtftfsgdfcgfgftdcf",
      invoiceAmount,
      totalValue,
      amountValue
    );

    if (invoiceAmount - totalValue < amountValue) {
      dispatch(
        setAppError({
          msg: "Invoice amount exceeds",
        })
      );
      return;
    }
    try {
      const formData = new FormData();
      formData.append("amount_received", amount);
      formData.append("file", file);
      formData.append("invoice_sent_date", date);
      console.log("ycgyuduyguggu.......", formData);
      if (fileData) {
        // formData.append("file", file);
        const response = await nodeinstance.put(
          `/dashboard/invoiceCostPlus/uploadPayment/${propData?.invoice_no}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setShowPromptElement(false);
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
        }
        console.log("success to be seen here......", response);
      }
    } catch (err) {
      console.log("error", err);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setShowPromptElement(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={(e) => submitHandler(e, file, propData)}
            className="w-full"
          >
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE SENT DATE
                </label>
                <input
                  type="Date"
                  value={date}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setDate(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE NUMBER
                </label>
                <input
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  disabled
                  value={propData?.invoice_no}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE AMOUNT
                </label>
                <input
                  type="number"
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={handleAmountChange}
                />
              </div>
              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">Upload File</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full "
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                  accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ m: 2 }}
              >
                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                >
                  {" "}
                  <p>Submit</p>
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
